import get from 'lodash/get';
import { i18n_t as $t } from '@/utils/i18n';
import { DEFAULT_TIME_SERIES } from '@/session-replay/helpers/common.util';
import { usesTodayReplayLibraryDefault } from '@/session-replay/helpers/replay-library-default';

const lockSavedFilters = ['All Replays'];

export const REPLAY_LIBRARY = 'replaylibrary';

export const PRODUCT_AREAS = 'productareas';

export const APP_HEALTH = 'apphealth';

export const SAVED_VIEWS_TYPES = {
    REPLAY_LIBRARY,
    PRODUCT_AREAS,
    APP_HEALTH,
};

export const formatSavedFilter = (savedFilter) => {
    const locked = lockSavedFilters.includes(savedFilter?.name) && isOwnedByPendo(savedFilter);

    let { name, description } = savedFilter;
    const filters = mapFilters(get(savedFilter, 'filters', []));

    if (locked && name === 'All Replays') {
        if (usesTodayReplayLibraryDefault()) {
            name = $t('Today');
            description = $t('savedFiltersUtils.This default view contains all replays captured today.');
            // Pin the window to the "Today" label so any stale/persisted timeSeries can't
            // widen this default view. Both the replay library and the saved-filter widget
            // read the locked view through formatSavedFilter, so this is the single place
            // the default window needs to live.
            filters.timeSeries = DEFAULT_TIME_SERIES;
        } else {
            name = $t('Last 7 days');
            description = $t(
                'savedFiltersUtils.This default view contains all replays captured from the last 7 days (and today).',
            );
        }
    }

    return {
        ...savedFilter,
        filters,
        locked,
        name,
        description,
    };
};

export function mapFilters (filters = []) {
    if (!filters) return {};

    const map = {};
    filters.forEach(({ type, value }) => {
        map[type] = value;
    });

    return map;
}

export function unmapFilters (filters = {}) {
    if (!filters) return [];

    return Object.entries(filters).map(([type, value]) => ({ type, value }));
}

export function isOwnedByPendo (savedFilter) {
    return get(savedFilter, 'createdByUser.username') === '--system-user--';
}

export function isOwnedByCurrentUser (savedFilter, currentUserId) {
    return get(savedFilter, 'createdByUser.id') === currentUserId;
}

export function normalizedOwner (savedFilter) {
    return isOwnedByPendo(savedFilter) ? 'Pendo' : savedFilter.createdByUser.username;
}
